module.exports = __webpack_public_path__ + "static/Yukie Iskandar-88f43b54e9e3cb427ddb13df065e41e9.jpg";